export default {
    init() {
        this.bidInputChange();
    },

    bidInputChange() {
        $('.bid-input-less').on('click', function (e) {
            e.preventDefault();
            let oldValue = $(this).parent().parent().find('input').val();
            let step = $(this).parent().parent().find('input').attr('step');
            let newVal = parseFloat(oldValue) - parseFloat(step);
            if(newVal>=0) {
                $(this).parent().parent().find('input').val(newVal).trigger('input');
            }
        });

        $('.bid-input-more').on('click', function (e) {
            e.preventDefault();
            let oldValue = $(this).parent().parent().find('input').val();
            let step = $(this).parent().parent().find('input').attr('step');
            let newVal = parseFloat(oldValue) + parseFloat(step);
            $(this).parent().parent().find('input').val(newVal).trigger('input');
        });

    },
}
